import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Input from "@mui/material/Input";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4
};

const AddTenantModal = (props) => {
    const {openAdd,setOpenAdd,tenantName,tenantCode,email,sftpHost, sftpUsername,sftpPassword,sessionExpire,handleAddChange,handleFileChange,handleAddSubmit,loading} = props

    return (
        <Modal open={openAdd} onClose={() => setOpenAdd(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h4" component="h2">
                    Add Tenant Data
                </Typography>
                <br></br>
                <Typography id="modal-modal-title" variant="h6" component="h6">
                    <FormControl fullWidth>
                        <TextField sx={{ mb: 1 }} id="tenantName" label="Tenant Name" value={tenantName} onChange={handleAddChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="tenantCode" label="Tenant Code" value={tenantCode} onChange={handleAddChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="email" label="Admin Email" value={email} onChange={handleAddChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="sftpConfig.host" label="SFTP Host" value={sftpHost} onChange={handleAddChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="sftpConfig.username" label="SFTP Username" value={sftpUsername} onChange={handleAddChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="sftpConfig.password" label="SFTP Password" value={sftpPassword} onChange={handleAddChange} />
                        <br></br>
                        <TextField sx={{ mb: 1 }} id="sessionExpire" type="number" label="Session Expiry Time (in hours)" value={sessionExpire} onChange={handleAddChange}  inputProps={{ min: 1 }}/>
                        <br></br>
                        Upload Tenant Logo:
                        <Input id="tenant_image_url" type="file" onChange={handleFileChange} />
                        <br></br>
                    </FormControl>
                </Typography>

                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    {loading ? <CircularProgress sx={{ color: "blue", marginLeft: "5%" }} /> :
                    <Button type="submit" variant="contained" color="primary" onClick={handleAddSubmit} disabled={!(tenantName && tenantCode && email)}>
                        Submit
                    </Button>}
                </Typography>
            </Box>
        </Modal>
    )
}

export default AddTenantModal
